import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import ClientContact from './Templates/ClientContact'
import ClientOffice from './Templates/ClientOffice'
import ClientAccount from './Templates/ClientAccount'
import SegmentSidebar from './Templates/SegmentSidebar'
import ContractSidebar from './ContractSidebar'
import ProjectSidebar from './Templates/ProjectSidebar'
import ExpertSidebar from './Templates/ExpertSidebar'
import InvoicingEntity from './Templates/InvoicingEntitySidebar'
import ParentAccount from './Templates/ParentAccount'
import ConsultationDetailsSidebar from './ConsultationDetailsSidebar'
import EPLCommentSidebar from './Templates/EPLCommentSidebar'

import CloseIcon from '@components/Icon/Close'
import './Sidebar.sass'

class Sidebar extends Component {
  static propTypes = {
    sidebarStore: PropTypes.object
  }

  loadTemplate = () => {
    const { template, props } = this.props.sidebarStore
    switch (template) {
      case 'client-contact':
        return <ClientContact {...props} />
      case 'client-account':
        return <ClientAccount {...props} />
      case 'client-office':
        return <ClientOffice {...props} />
      case 'segment':
        return <SegmentSidebar {...props} />
      case 'contract':
        return <ContractSidebar {...props} />
      case 'project':
        return <ProjectSidebar {...props} />
      case 'expert':
        return <ExpertSidebar {...props} />
      case 'invoicing-entity':
        return <InvoicingEntity {...props} />
      case 'parent-account':
        return <ParentAccount {...props} />
      case 'consultation-details':
        return <ConsultationDetailsSidebar {...props} />
      case 'epl-comments':
        return <EPLCommentSidebar {...props} />
      default:
        return null
    }
  }

  render () {
    const { sidebarStore } = this.props

    if (!sidebarStore.active && !sidebarStore.closing) {
      return null
    }

    const classes = classNames({
      'sidebar-wrapper': true,
      'sidebar-wrapper--closing': sidebarStore.closing
    })

    return (
      <div className={classes}>
        <div
          className='sidebar-wrapper__background'
          onClick={sidebarStore.closeSidebar}
        />
        <div className='sidebar-wrapper__content'>
          <div className='exit-wrapper'>
            <div className='icon-wrapper' onClick={sidebarStore.closeSidebar}>
              <CloseIcon />
            </div>
          </div>
          {this.loadTemplate()}
        </div>
      </div>
    )
  }
}

export default inject('sidebarStore')(observer(Sidebar))
